import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { fetchModelOverview } from './fetch-model-overview';
import {
  // ModelOverview,
  ShowroomModel,
  ModelConfig,
  CarlineConfigModel,
} from '../typings/model-overview';
import { fetchFeedbackReviews } from './fetch-feedback-reviews';
import _, { uniqBy } from 'lodash';
import { ReviewModel, ReviewsApiConfig } from '../typings/reviews';
import { ImageModel } from '../typings/images-model-map';
import { AppConstants } from '../utils/app-constants';
import { ErrorHandlingModel } from '../hooks-store/typings/store';
import ErrorCodes from '../error-handling/error-codes';
import ErrorMessages from '../error-handling/error-mesagges';
import { ModelConfiguration } from '..';
import { fetchReviewsDataVersion } from './fetch-data-version';

interface FetchOptions {
  readonly faServicesUrl: string;
  readonly reviewsHostData?: ReviewsApiConfig;
  readonly localeService: LocaleServiceV1;
  readonly serviceConfigsServiceConfig?: string;
  readonly showRoomModel?: ShowroomModel | undefined;
  readonly mockIds?: string;
  readonly mocksBaseUrl?: string;
  readonly imageModel?: ImageModel;
  readonly modelConfiguration?: ModelConfiguration;
  readonly apiKeyContent?: string;
}

const getModelOverviewError = (errorHandling: ErrorHandlingModel[]) =>
  uniqBy(
    [
      {
        errorCode: ErrorCodes.FetchModelOverviewError,
        errorMessage: ErrorMessages.FetchModelOverviewError,
      },
      ...errorHandling,
    ],
    'errorCode',
  );

/**
 * Get model data according with model given by showroom or feature-app configuration
 * @param modelConfiguration
 * @param showRoomModel
 * @param modelsConfig
 * @returns CarlineConfigModel | undefined
 */
const getModelData = (
  modelConfiguration?: ModelConfiguration,
  showRoomModel?: ShowroomModel,
  modelsConfig?: ModelConfig,
  imageModel?: ImageModel,
): CarlineConfigModel | undefined => {
  if (imageModel) return imageModel;
  if (!modelsConfig) return undefined;
  if (modelConfiguration && modelConfiguration.carlineId) {
    return modelsConfig[modelConfiguration.carlineId];
  }
  if (modelConfiguration && modelConfiguration.slug) {
    return _.find(
      modelsConfig,
      model => model.slug === modelConfiguration.slug,
    );
  }
  if (showRoomModel && showRoomModel.carlineId) {
    return modelsConfig[showRoomModel.carlineId];
  }
  return undefined;
};
export function fetchInitialReviewsDataCSR({
  faServicesUrl,
  localeService,
  reviewsHostData,
  serviceConfigsServiceConfig,
  showRoomModel,
  mockIds,
  mocksBaseUrl,
  modelConfiguration,
  imageModel,
  apiKeyContent,
}: FetchOptions): Promise<any> {
  const { language, countryCode, currency } = localeService;
  let modelData: CarlineConfigModel | undefined;
  let fetchedModelOverview: ModelConfig | null;
  let errorHandling: ErrorHandlingModel[] = [];
  const fetchPromise = fetchModelOverview({
    language,
    countryCode,
    currency,
    faServicesUrl,
    serviceConfigsServiceConfig,
    mockIds,
    mocksBaseUrl,
  })
    .then(async (result: any) => {
      if (result.errorStatus) {
        fetchedModelOverview = null;
      } else {
        fetchedModelOverview = result.data;
        modelData = getModelData(
          modelConfiguration,
          showRoomModel,
          result.data,
          imageModel,
        );
      }
      if (result.errorStatus || typeof modelData === 'undefined') {
        errorHandling = getModelOverviewError(errorHandling);
      }

      const dataVersion = await fetchReviewsDataVersion({
        reviewsHostData,
        apiKeyContent,
      });
      return (
        modelData &&
        fetchFeedbackReviews({
          reviewsHostData,
          dataVersion,
          apiKeyContent,
          model: modelData?.fiveStarsName || modelData?.name || '',
          size: AppConstants.ALL_REVIEWS_SIZE as number,
          page: AppConstants.API_PAGINATION_BASE as number,
        }).then((reviews: ReviewModel) => {
          reviews.dataVersion = dataVersion;
          reviews.modelConfiguration = {
            ...modelData,
            name: modelData?.name || '',
            slug: modelData?.slug || '',
            modelYear: modelData?.modelYear || '',
            background: modelData?.background || '',
            carImage: modelData?.carImage || '',
            carImageAlt: modelData?.carImageAlt || '',
            requestName: modelData?.fiveStarsName || modelData?.name || '',
            isNewImage: modelData?.isNewImage,
          };
          return reviews;
        })
      );
    })
    .catch((error: Error) => {
      fetchedModelOverview = null;
      errorHandling = getModelOverviewError(errorHandling);
      console.log('Error Fetch Model Overview', error);
      throw errorHandling;
    });
  return fetchPromise;
}
